"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LOCK_ACTION;
(function (LOCK_ACTION) {
    LOCK_ACTION[LOCK_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    LOCK_ACTION[LOCK_ACTION["ERROR"] = 1] = "ERROR";
    LOCK_ACTION[LOCK_ACTION["REQUEST"] = 2] = "REQUEST";
    LOCK_ACTION[LOCK_ACTION["RESPONSE"] = 3] = "RESPONSE";
    LOCK_ACTION[LOCK_ACTION["RELEASE"] = 4] = "RELEASE";
})(LOCK_ACTION = exports.LOCK_ACTION || (exports.LOCK_ACTION = {}));
//# sourceMappingURL=lock.js.map